import { render, staticRenderFns } from "./workorderservice.vue?vue&type=template&id=499410d6&"
import script from "./workorderservice.vue?vue&type=script&lang=js&"
export * from "./workorderservice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports